// extracted by mini-css-extract-plugin
module.exports = {"seeMore":"hit_commentaries_list_see_more-module__seeMore--1Y0qf","tooltip":"hit_commentaries_list_see_more-module__tooltip--3AbM4"};